import Parse from "parse";

import type { Media } from "./Media";
import type { Schedule_Execution } from "./Schedule_Execution";
import type { _Role } from "./_Role";

type OD3_Tenant = Parse.Object;

export interface Schedule_Execution_StepAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  comment?: string;
  description?: string;
  done: boolean;
  fields: any[];
  media: Parse.Relation<Schedule_Execution_Step, Media>;
  roles: Parse.Relation<Schedule_Execution_Step, _Role>;
  scheduleexecution?: Schedule_Execution;
  tenant: OD3_Tenant;
  title?: string;
}

export class Schedule_Execution_Step extends Parse.Object<Schedule_Execution_StepAttributes> {
  static className: string = "OD3_Maintenance_Schedule_Execution_Step";

  constructor(data?: Partial<Schedule_Execution_StepAttributes>) {
    super("OD3_Maintenance_Schedule_Execution_Step", data as Schedule_Execution_StepAttributes);
  }

  get comment(): string | undefined {
    return super.get("comment");
  }
  set comment(value: string | undefined) {
    super.set("comment", value);
  }
  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get done(): boolean {
    return super.get("done");
  }
  set done(value: boolean) {
    super.set("done", value);
  }
  get fields(): any[] {
    return super.get("fields");
  }
  set fields(value: any[]) {
    super.set("fields", value);
  }
  get media(): Parse.Relation<Schedule_Execution_Step, Media> {
    return super.relation("media");
  }
  get roles(): Parse.Relation<Schedule_Execution_Step, _Role> {
    return super.relation("roles");
  }
  get scheduleexecution(): Schedule_Execution | undefined {
    return super.get("scheduleexecution");
  }
  set scheduleexecution(value: Schedule_Execution | undefined) {
    super.set("scheduleexecution", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Schedule_Execution_Step", Schedule_Execution_Step);
